import ObjectTableController from "./object_table_controller"

export default class ContactsObjectTableController extends ObjectTableController {
  static values = {
    ...ObjectTableController.values,
    listTypeFriendlyName: "contact",
    subjectType: "contact",
  }

  connect() {
    super.connect()
  }

  onAdd() {
    window.Turbo.visit(this.addItemUrlValue)
  }
}
